import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    FETCH_OPTIONAL_FEATURE,
    FETCH_OPTIONAL_FEATURE_FETCHING,
    FETCH_OPTIONAL_FEATURE_SUCCESS,
    FETCH_OPTIONAL_FEATURE_FAIL,
    UPDATE_OPTIONAL_FEATURE,
    UPDATE_OPTIONAL_FEATURE_UPDATING,
    UPDATE_OPTIONAL_FEATURE_SUCCESS,
    UPDATE_OPTIONAL_FEATURE_FAIL
} from '../actions/ActionTypes';
import { handlingErrorCallback, handlingSuccessCallback } from 'sagas/sagasUtils';

// worker
export function* fetchOptionalFeature(action = {}) {
    try {
        yield put({
            type: FETCH_OPTIONAL_FEATURE_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/userprofile-service/userprofile/optional-feature/${action.featureType.toLowerCase().replace('_', '-')}`
        );

        yield put({
            type: FETCH_OPTIONAL_FEATURE_SUCCESS,
            optionalFeature: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_OPTIONAL_FEATURE_FAIL,
            optionalFeature: {}
        });
    }
}

export function* updateOptionalFeature(action = {}) {
    try {
        yield put({
            type: UPDATE_OPTIONAL_FEATURE_UPDATING
        });

        const response = yield call(
            gcApi.put,
            `/userprofile-service/userprofile/optional-feature/${action.featureType
                .toLowerCase()
                .replace('_', '-')}/${action.optionType.toLowerCase().replace('_', '-')}${
                action.displayName ? `/${action.displayName}` : ''
            }`
        );

        handlingSuccessCallback(action.callback, response);

        yield put({
            type: UPDATE_OPTIONAL_FEATURE_SUCCESS,
            optionalFeature: response.data
        });
    } catch (e) {
        handlingErrorCallback(action.callback, e);
        yield put({
            type: UPDATE_OPTIONAL_FEATURE_FAIL,
            optionalFeature: {}
        });
    }
}

// watcher
export const optionalFeatureSagas = [
    takeEvery(FETCH_OPTIONAL_FEATURE, fetchOptionalFeature),
    takeEvery(UPDATE_OPTIONAL_FEATURE, updateOptionalFeature)
];
